import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Table, Row, Attributes, Expander, InfoIcon, List } from '../components';
export const endpoints = [{
  param: 'PUT',
  value: '/nodes/entity/SmartVault.Accounting.Firm/{firm_id}/SmartVault.Accounting.FirmClient/{client_id}/{engagement_type}',
  subtitle: 'Create engagement',
  link: '#create-an-engagement'
}, {
  param: 'PUT',
  value: '/engagement-template/client-engagement',
  subtitle: 'Create engagement with specific template',
  link: '#create-an-engagement-with-a-specific-template'
}, {
  param: 'POST',
  value: '/nodes/entity/SmartVault.Accounting.Firm/{firm_id}',
  subtitle: 'Bulk engagement creation',
  link: '#create-an-engagement-for-all-clients'
}, {
  param: 'POST',
  value: '/nodes/entity/SmartVault.Accounting.Firm/{firm_id}/SmartVault.Accounting.FirmClient/{client_id}/SmartVault.Accounting.ClientSalesTaxEngagement/{engagement_id}',
  subtitle: 'Edit engagement',
  link: '#edit-an-engagement'
}];
export const engagementTypesTable = [{
  param: 'Accounting services',
  value: 'SmartVault.Accounting.ClientAccountingServicesAnnualEngagement'
}, {
  param: 'Financial services',
  value: 'SmartVault.Accounting.ClientFinancialServicesEngagement'
}, {
  param: 'General annual',
  value: 'SmartVault.Core.ClientGeneralAnnualEngagement'
}, {
  param: 'Investment',
  value: 'SmartVault.Accounting.ClientInvestmentEngagement'
}, {
  param: 'Payroll',
  value: 'SmartVault.Accounting.ClientPayrollEngagement'
}, {
  param: 'Project',
  value: 'SmartVault.Core.ClientProjectEngagement'
}, {
  param: 'Sales tax',
  value: 'SmartVault.Accounting.ClientSalesTaxEngagement'
}, {
  param: 'Tax engagement',
  value: 'SmartVault.Accounting.ClientTaxEngagement'
}, {
  param: 'Wealth management',
  value: 'SmartVault.Accounting.ClientWealthManagementEngagement'
}];
export const createEntity = [{
  param: 'PUT',
  value: '/nodes/entity/SmartVault.Accounting.Firm/{firm_id}/SmartVault.Accounting.FirmClient/{client_id}/{engagement_type}'
}];
export const createEntityTemplate = [{
  param: 'PUT',
  value: '/engagement-template/client-engagement'
}];
export const bulkCreateEngagement = [{
  param: 'POST',
  value: '/nodes/entity/SmartVault.Accounting.Firm/{firm_id}'
}];
export const editEngagement = [{
  param: 'POST',
  value: '/nodes/entity/SmartVault.Accounting.Firm/{firm_id}/SmartVault.Accounting.FirmClient/{client_id}/SmartVault.Accounting.ClientSalesTaxEngagement/{engagement_id}'
}];
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  endpoints,
  engagementTypesTable,
  createEntity,
  createEntityTemplate,
  bulkCreateEngagement,
  editEngagement,
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <h1 {...{
      "id": "engagements"
    }}>{`Engagements`}</h1>
    <Row mdxType="Row">
	<div>
		<p>
			SmartVault's API allows the creation of engagements as entities{' '}
			<a href="#create-an-engagement-with-a-specific-template">with a specific template</a> or{' '}
			<a href="#create-an-engagement">without them</a>, related to a certain client and the ability to{' '}
			<a href="#edit-an-engagement">modify</a> those engagements individually at any time.
			<br />
			<br />
			You can also add engagements <a href="#create-an-engagement-for-all-clients">as a bulk</a>.<br />
			<br />
			You can also refer to composite endpoints, an alternative simplified process of managing engagements <a target="_blank" href="/composite-endpoints#the-engagement-object">
			here
			</a>.
			<br />
		</p>
	</div>
	<Table title="Endpoints" rows={endpoints} mdxType="Table" />
    </Row>
    <br />
    <br />
    <br />
    <hr style={{
      "width": "50%"
    }} />
    <br />
    <br />
    <h2 {...{
      "id": "engagement-types"
    }}>{`Engagement types`}</h2>
    <p>{`Below you can find a table with the equivalences for the engagement type and its name for the SmartVault API parameter.`}<br />{`
This will be useful for adding / updating engagements.`}</p>
    <br />

    <Table data="info" title="Engagement types" rows={engagementTypesTable} mdxType="Table" />
    <br />
    <br />
    <br />
    <br />
    <hr />
    <br />
    <br />

    <h2 {...{
      "id": "create-an-engagement"
    }}>{`Create an engagement`}</h2>
    <Row mdxType="Row">
	<div>
		<p>
			The firm id, the client id where the engagement is going to be created and the engagement type are the
			path parameter for this request. Depending of the type of engagement that you are going to add to the
			client, you'll need to specify one type or another in the request path.
			<br />
			<br />
			<List values={[{
            title: 'Each client can have multiple of every type of engagement.',
            value: ' For time bound engagements (All except for project engagement) different years have to be specified in order to have multiple engagements of the same type.'
          }, {
            title: 'Project engagements are the only non time bound engagement and clients can have multiples of these as long as the project name is unique.'
          }]} mdxType="List" />
		</p>
	</div>
	<Table title="Create an engagement" rows={createEntity} mdxType="Table" />
    </Row>
    <br />
    <br />
    <p><strong parentName="p">{`Parameters`}</strong></p>
    <hr></hr>
    <Attributes items={[{
      name: 'firm_id',
      type: 'string',
      description: "The account's alphanumerical identification."
    }, {
      name: 'client_id',
      type: 'string',
      description: 'Alphabetic representation of the client ID on which the engagement will be created.'
    }, {
      name: 'engagement_type',
      type: 'string',
      description: 'SmartVault equivalent name for the engagement type.'
    }]} mdxType="Attributes" />
    <br />
    <InfoIcon mdxType="InfoIcon" /> Find more info on how to retrieve the account's id <a href="/api/entities/retrieve-an-entity#the-account-id" target="_blank">
	here
    </a>.<br />
    <InfoIcon mdxType="InfoIcon" /> Find the value needed for the "engagement_type" in the engagement types table <a href="#engagement-types">
	here
    </a>.<br />
    <br />
    <br />
    <p>{`So if you wanted to add a certain engagement of "Payroll" type, the request path should look like:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`/nodes/entity/SmartVault.Accounting.Firm/{firm_id}/SmartVault.Accounting.FirmClient/{client_id}/SmartVault.Accounting.ClientPayrollEngagement;
`}</code></pre>
    <br />
    <br />
    <p><strong parentName="p">{`Body parameters`}</strong></p>
    <hr></hr>
    <p>{`For every new engagement added, you'll need to specify at least both the "engagement_type" specified above and the "entity_definition" in the request body.`}</p>
    <Expander title="body parameters" mdxType="Expander">
	<List values={[{
        title: 'entity_definition',
        value: 'Required string that needs to be the same value as the "engagement_type" path param, but removing the "client" word from it.\r\nCheck the example below for clarity.'
      }, {
        title: 'period',
        value: 'Optional integer value of the year for the engagement. Not applicable if the engagement type is "Project"'
      }, {
        title: 'tags',
        value: 'Optional array of tags to identify the engagement.'
      }, {
        title: 'aliases',
        value: 'Optional object with "domain", "key" and "value" keys that works as tag/identity.\r\ne.g.: when creating an engagement you assign it an id to uniquely identify/lookup it later.'
      }, {
        title: 'project_name',
        value: 'When adding "Project" type engagements there\'s an extra required parameter called "project_name" that you need to specify.'
      }]} mdxType="List" />
    </Expander>
    <br />
    <br />
    <p><strong parentName="p">{`Request`}</strong></p>
    <hr></hr>
    <p>{`Example of a request to add a new engagement to a client.`}</p>
    <Expander title="example request" mdxType="Expander">
      <pre><code parentName="pre" {...{
          "className": "language-javascript"
        }}>{`/*
    The request path for this should be:
        "/nodes/entity/SmartVault.Accounting.Firm/{firm_id}/SmartVault.Accounting.FirmClient/{client_id}/SmartVault.Accounting.ClientSalesTaxEngagement"
    Notice how the "engagement_type" param on the path ("SmartVault.Accounting.ClientSalesTaxEngagement") is the same string as the "entity_definition" on the body
    but removing the "client" word from it.
*/
{
   "entity": {
      "meta_data": {
         "entity_definition": "SmartVault.Accounting.TaxEngagement",
      },
      "smart_vault": {
         "accounting": {
            "engagement": {
                //"project_name": "Project name", // only required when adding an engagement of Project type.
               "period": 2020,
               "tags": [
                  {
                     "value": "tag1"
                  }
               ],
               "aliases": [
                  {
                     "Domain": "domain",
                     "Type": "type",
                     "Value": "value"
                  }
               ]
            },
         }
      }
   },
}
`}</code></pre>
    </Expander>
    <br /><br />
    <p><strong parentName="p">{`Response`}</strong></p>
    <hr></hr>
    <p>{`Returns a `}<a parentName="p" {...{
        "href": "/api/terminology#node-response"
      }}>{`node response object`}</a>{` with the newly added engagement.`}</p>
    <Expander title="success object" mdxType="Expander">
      <pre><code parentName="pre" {...{
          "className": "language-javascript"
        }}>{`{
    "error": {
        "success": true
    },
    "message": {
        "name": "5CV-VR9CLEG1xEsL_OQbQA",
        "createdOn": "2020-07-02T09:28:13-05:00",
        "modifiedOn": "2020-07-02T09:28:13-05:00",
        "uri": "/nodes/entity/SmartVault.Accounting.Firm/{firm_id}/SmartVault.Accounting.FirmClient/{client_id}/SmartVault.Accounting.ClientSalesTaxEngagement/{engagement_id}",
        "dav_uri": "/nodes/pth/SmartVault Account/Clients/E-H/Engagement creation examples/Sales Tax 2020", // "Engagement creation examples" is the Client's name.
        "your_permissions": 113
    }
}
`}</code></pre>
    </Expander>
    <br />
    <p>{`Returns an `}<a parentName="p" {...{
        "href": "/api/errors#error-object"
      }}>{`error object`}</a>{` if the "engagement_type" defined in the request path and the "entity_definition" body parameter doesn't match.`}</p>
    <Expander title="error object" mdxType="Expander">
      <pre><code parentName="pre" {...{
          "className": "language-javascript"
        }}>{`{
    "error": {
        "success": false,
        "error_code": -2147467259,
        "error_text": "relationship.EntityDefinition2Id"
    }
}
`}</code></pre>
    </Expander>
    <br />
    <p>{`Returns an `}<a parentName="p" {...{
        "href": "/api/errors#error-object"
      }}>{`error object`}</a>{` if the entity type defined in the request path already exists. Remember only one engagement of each type is allowed for each client.`}</p>
    <Expander title="error object" mdxType="Expander">
      <pre><code parentName="pre" {...{
          "className": "language-javascript"
        }}>{`{
    "error": {
        "success": false,
        "error_code": -1593835510,
        "error_text": "Object already exists.",
        "instance_guid": "254a30fa-4ba5-42db-91ed-9a1bfbe47d6e",
        "status_code": 500
    }
}
`}</code></pre>
    </Expander>
    <br />
    <br />
    <br />
    <br />
    <hr />
    <br />
    <br />

    <h2 {...{
      "id": "create-an-engagement-with-a-specific-template"
    }}>{`Create an engagement with a specific template`}</h2>
    <Row mdxType="Row">
	<div>
		<p>
			The main usage difference between adding an engagement and a template specific engagement is that when you
			create an engagement it uses a set of rules to determine which template is selected. Where a specific
			template differs in that it does not follow the rule set and you are picking which template exactly to use.
			<br />
			<br />
			For this request, unlike the previous one, specifying the required parameters (account ID and client ID) must
			be done in the body of the request.
		</p>
	</div>
	<Table title="Create an engagement with a specific template" rows={createEntityTemplate} mdxType="Table" />
    </Row>
    <br />
    <br />
    <p><strong parentName="p">{`Body parameters`}</strong></p>
    <hr></hr>
    <Attributes items={[{
      name: 'account_id',
      type: 'string (required)',
      description: "The account's alphanumerical identification."
    }, {
      name: 'client_id',
      type: 'string (required)',
      description: "The client's alphanumerical identification."
    }, {
      name: 'template_api_name',
      type: 'string (required)',
      description: 'The name of the template being used to create the engagement.\r\nThe engagement type is automatically obtained based on this value.'
    }, {
      name: 'year',
      type: 'string (optional)',
      description: 'The client\'s alphanumerical identification. Not applicable if the engagement type is "Project"'
    }, {
      name: 'project_name',
      type: 'string (required if Project type)',
      description: 'When adding "Project" type engagements there\'s an extra required parameter called "project_name" that you need to specify.'
    }]} mdxType="Attributes" />
    <br />
    <p>{`Check `}<a parentName="p" {...{
        "href": "/templates#template-types"
      }}>{`here`}</a>{` for more information on how to get all the values available for the "template_api_name" field.`}</p>
    <br />
    <p><strong parentName="p">{`Request`}</strong></p>
    <hr></hr>
    <Expander title="request example" mdxType="Expander">
      <pre><code parentName="pre" {...{
          "className": "language-javascript"
        }}>{`{
    "account_id": "h4bEql123ESe5dwNoGfMVw",
    "template_api_name": "SmartVault.Accounting.InvestmentEngagementTemplate",
    "year": 2022,
    "client_id": "kQaQUoO123k6G0mYQaJrMMw"
}
`}</code></pre>
    </Expander>
    <br />
    <br />
    <p><strong parentName="p">{`Response`}</strong></p>
    <hr></hr>
    <p>{`Returns a `}<a parentName="p" {...{
        "href": "/api/terminology#node-response"
      }}>{`node response object`}</a>{` pointing to the newly created engagement.`}</p>
    <Expander title="success object" mdxType="Expander">
      <pre><code parentName="pre" {...{
          "className": "language-javascript"
        }}>{`{
    "error": {
        "success": true
    },
    "message": {
        "name": "qJLhk9-RvE6yQMfHZxsitA",
        "createdOn": "2020-07-02T18:09:14Z",
        "modifiedOn": "2020-07-02T18:09:14Z",
        "uri": "/nodes/entity/SmartVault.Accounting.Firm/{firm_id}/SmartVault.Accounting.FirmClient/{client_id}/SmartVault.Accounting.ClientSalesTaxEngagement/qJLhk9-RvE6yQMfHZxsitA"
    }
}
`}</code></pre>
    </Expander>
    <br />
    <br />
    <br />
    <br />
    <hr />
    <br />
    <br />

    <h2 {...{
      "id": "create-an-engagement-for-all-clients"
    }}>{`Create an engagement for all clients`}</h2>
    <Row mdxType="Row">
	<div>
		<p>
			SmartVault allows the creation of a engagement for every client in an account in a single request.
			<br />
			<br />
			<List values={[{
            title: 'This process can take a while depending on the number of clients you have in the account specified.'
          }, {
            title: 'You will receive an email confirming the addition of the engagement to all clients with the subject "Your SmartVault create bulk engagement request has completed for "Account name".'
          }]} mdxType="List" />
		</p>
	</div>
	<Table title="Create an engagement for all clients" rows={bulkCreateEngagement} mdxType="Table" />
    </Row>
    <br />
    <br />
    <p><strong parentName="p">{`Parameters`}</strong></p>
    <hr></hr>
    <Attributes items={[{
      name: 'firm_id',
      type: 'string',
      description: "The account's alphanumerical identification."
    }]} mdxType="Attributes" />
    <InfoIcon mdxType="InfoIcon" /> You can find more info on how to retrieve the account's id <a href="/api/entities/retrieve-an-entity#the-account-id" target="_blank">
	here
    </a>.
    <br />
    <br />
    <br />
    <p><strong parentName="p">{`Body parameters`}</strong></p>
    <hr></hr>
    <p>{`The bulk engagement creation has 4 different parameters related to the engagements being added.`}<br />{`
You'll need to specify at least both the "Type" (and the "Year" if it's not a "Project" engagement).`}<br /><br />{`
This "Type" value is a required string that needs to be the same value as the "entity_definition" body param while adding an individual engagement.`}<br /></p>
    <InfoIcon mdxType="InfoIcon" /> Find the value needed for the "Type" parameter in the engagement types table <a href="#engagement-types">
	here
    </a>.<br />
    <br />
    <br />
    <p><strong parentName="p">{`Request`}</strong></p>
    <hr></hr>
    <p>{`Example of a request to add a new engagement to a client.`}</p>
    <Expander title="example request" mdxType="Expander">
      <pre><code parentName="pre" {...{
          "className": "language-javascript"
        }}>{`{
   "query":false,
   "verb":{
      "action":"createbulkengagement",
      "parameters":[
         {
            "key":"Type",
            "value":"SmartVault.Accounting.PayrollEngagement"
         },
         {
            "key":"Year",
            "value":2021
         },
         {
            "key":"TemplateApiName"
         },
         {
            "key":"ClientTypeId"
         }
      ]
   }
}
`}</code></pre>
    </Expander>
    <br /><br />
    <p><strong parentName="p">{`Response`}</strong></p>
    <hr></hr>
    <p>{`Returns a `}<a parentName="p" {...{
        "href": "/api/terminology#node-response"
      }}>{`node response object`}</a>{` that points to the account root where the engagement has been added.`}</p>
    <Expander title="success object" mdxType="Expander">
      <pre><code parentName="pre" {...{
          "className": "language-javascript"
        }}>{`{
    "error": {
        "success": true
    },
    "message": {
        "name": "dZz88AeDg0GnvBRoNiJ_7w",
        "createdOn": "2020-07-02T13:26:04-05:00",
        "modifiedOn": "2020-07-02T13:26:04-05:00",
        "uri": "/nodes/entity/SmartVault.Accounting.Firm/{firm_id}",
        "dav_uri": "/nodes/pth/SmartVault Account",
        "your_permissions": 97
    }
}
`}</code></pre>
    </Expander>
    <br />
    <p>{`Returns an `}<a parentName="p" {...{
        "href": "/api/errors#error-object"
      }}>{`error object`}</a>{` if any of the required keys are missing.`}</p>
    <Expander title="error object" mdxType="Expander">
      <pre><code parentName="pre" {...{
          "className": "language-javascript"
        }}>{`{
    "error": {
        "success": false,
        "error_code": -2147467259,
        "error_text": "The given key was not present in the dictionary."
    }
}
`}</code></pre>
    </Expander>
    <br />
    <br />
    <br />
    <br />
    <hr />
    <br />
    <br />

    <h2 {...{
      "id": "edit-an-engagement"
    }}>{`Edit an engagement`}</h2>
    <Row mdxType="Row">
	<div>
		<p>SmartVault allows the modification of certain engagement parameters.</p>
	</div>
	<Table title="Edit an engagement" rows={editEngagement} mdxType="Table" />
    </Row>
    <br />
    <br />
    <p><strong parentName="p">{`Parameters`}</strong></p>
    <hr></hr>
    <Attributes items={[{
      name: 'firm_id',
      type: 'string',
      description: "The account's alphanumerical identification."
    }, {
      name: 'client_id',
      type: 'string',
      description: 'Alphanumeric representation of the client ID on which the engagement will be created.'
    }, {
      name: 'engagement_id',
      type: 'string',
      description: 'Alphanumeric string that represents the engagement to be modified.'
    }]} mdxType="Attributes" />
    <br />
    <br />
    <p><strong parentName="p">{`Body parameters`}</strong></p>
    <hr></hr>
    <Expander title="body parameters" mdxType="Expander">
	<List values={[{
        title: 'entity_definition',
        value: 'Required string that needs to be the same value as the actual "engagement_type" of the engagement being edited.'
      }, {
        title: 'period',
        value: 'Optional integer value of the year for the engagement. Not applicable if the engagement type is "Project".'
      }, {
        title: 'tags',
        value: 'Optional array of tags to identify the engagement.'
      }, {
        title: 'aliases',
        value: 'Optional object with "domain", "key" and "value" keys that works as tag/identity.\r\ne.g.: when creating an engagement you assign it an id to uniquely identify/lookup it later.'
      }, {
        title: 'project_name',
        value: 'When editing a "Project" type engagement there\'s an extra required parameter called "project_name" that you need to specify.'
      }]} mdxType="List" />
    </Expander>
    <br />
    <p>{`Example of a request to edit an engagement.`}</p>
    <Expander title="body request" mdxType="Expander">
      <pre><code parentName="pre" {...{
          "className": "language-javascript"
        }}>{`{
   "query":false,
   "update":{
      "entity":{
         "meta_data":{
            "entity_definition":"SmartVault.Accounting.SalesTaxEngagement"
         },
         "smart_vault":{
            "accounting":{
               "engagement":{
                  "tags":[
                     {
                        "value": "tags1"
                     }
                  ],
                  "aliases":[],
                  "period":"2032"
               }
            }
         }
      }
   }
}
`}</code></pre>
    </Expander>
    <br />
    <br />
    <p><strong parentName="p">{`Response`}</strong></p>
    <hr></hr>
    <p>{`Returns a `}<a parentName="p" {...{
        "href": "/api/terminology#node-response"
      }}>{`node response object`}</a>{` of the engagement edited.`}</p>
    <Expander title="success object" mdxType="Expander">
      <pre><code parentName="pre" {...{
          "className": "language-javascript"
        }}>{`{
    "error": {
        "success": true
    },
    "message": {
        "name": "qJLhk9-RvE6yQMfHZxsitA",
        "createdOn": "2020-07-02T14:47:42-05:00",
        "modifiedOn": "2020-07-02T14:47:42-05:00",
        "uri": "/nodes/entity/SmartVault.Accounting.Firm/{firm_id}/SmartVault.Accounting.FirmClient/{client_id}/SmartVault.Accounting.ClientSalesTaxEngagement/{engagement_id}",
        "dav_uri": "/nodes/pth/SmartVault Account/Clients/T-Z/Updated name/Sales Tax 2012",
        "your_permissions": 113
    }
}
`}</code></pre>
    </Expander>
    <br />
    <p>{`Returns an `}<a parentName="p" {...{
        "href": "/api/errors#error-object"
      }}>{`error object`}</a>{` if any of the required params are missing.`}</p>
    <Expander title="error object" mdxType="Expander">
      <pre><code parentName="pre" {...{
          "className": "language-javascript"
        }}>{`{
    "error": {
        "success": false,
        "error_code": -2147467259,
        "error_text": "The method or operation is not implemented."
    }
}
`}</code></pre>
    </Expander>
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      